import { Component, OnInit, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { IReducers } from 'app/store/reducers';
import { openDialog } from 'app/store/actions/page.action';
import { InfoTipsComponent } from 'app/dialogs/info-tips/info-tips.component';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-info-tip-button',
  templateUrl: './info-tip-button.component.html',
  styleUrls: ['./info-tip-button.component.scss'],
})
export class InfoTipButtonComponent implements OnInit {
  @Input() type: string;

  iconPaperPlane = faPaperPlane;

  constructor(private store: Store<IReducers>) {}

  ngOnInit() {}

  onInfoImageClick() {
    if (this.type) {
      this.store.dispatch(
        openDialog({
          dialogData: {
            content: InfoTipsComponent,
            title: 'Tips',
            canClose: true,
            dialogMinWidth: '700px',
            componentData: {
              type: this.type,
            },
          },
        })
      );
    }
  }
}
